import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {EndoMultiToothExamAutoFillConfigurationModel} from '../../../../models/forms/custom/mti/endo-multi-tooth-exam-auto-fill-configuration.model';
import {MtiService} from '../../../../services/form/mti.service';
import {TdoTableV2Component} from '../../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import {DialogService} from '../../../../services/dialog.service';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {TdoTableSelectionEvent} from '../../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import {ConfigurationService} from '../../configuration.service';
import {MessagingService} from '../../../../services/messaging.service';
import {MessagingConstants} from '../../../../models/MessagingConstants';
import {MatSnackBar} from '@angular/material/snack-bar';
import { DxoItemDraggingModule } from 'devextreme-angular/ui/nested';

@Component({
    selector: 'app-mte-autofill',
    templateUrl: './mte-autofill.component.html',
    styleUrls: ['./mte-autofill.component.scss']
})
export class MteAutofillComponent implements OnInit {
    @ViewChild('table') table: TdoTableV2Component;

    configs: EndoMultiToothExamAutoFillConfigurationModel[] = [];
    selectedConfig: EndoMultiToothExamAutoFillConfigurationModel;
    selectedKeys: string;
    newItemCreted=false;
    isDataChanged=false;

    isLoading = true;

    constructor(private mtiService: MtiService,
                private messagingService: MessagingService,
                private snackBar: MatSnackBar,
                private dialogService: DialogService,
                private changeDet: ChangeDetectorRef,
                public configurationService: ConfigurationService) {

        this.onTReorder = this.onTReorder.bind(this) ;

    }

    ngOnInit(): void {
      this.loaddata();

    }


    loaddata() {
        this.mtiService.getExamAutoFills().subscribe((res) => {
            this.configs = res;
            // this.selectedConfig = this.configs[0];
            console.log('loaded' ,this.configs  );

            setTimeout(() => {
              if(this.newItemCreted) {
                let i = this.configs.length -1;
                this.selectedConfig = this.configs[i];
                this.selectedKeys = this.configs[i].AutoFillID;
                this.newItemCreted=false;
              }
              else {
                this.selectedConfig = this.configs[0];
                this.selectedKeys = this.configs[0].AutoFillID;
              }
              this.isDataChanged =false;
            }, 1000);

            this.isLoading = false;
        });
    }

    // Zoli

    onSelectionChanged(e)  {

        this.selectedConfig=new EndoMultiToothExamAutoFillConfigurationModel();

        if (e) {
          this.selectedConfig = e[0];
        }

       this.changeDet.detectChanges();

        console.log('changed' , this.selectedConfig);

    }


    onTDragStart(e) {

        e.itemData = e.fromData[e.fromIndex];

    }

    onTAdd(e) {

        e.toData.splice(e.toIndex, 0, e.itemData);

    }
    onTRemove(e: any) {
        e.fromData.splice(e.fromIndex, 1);
    }

    onTReorder(e: any) {

        e.fromData.splice(e.fromIndex, 1);
        e.toData.splice(e.toIndex, 0, e.itemData);

        try {
            for (let i = 0; i < e.toData.length; i++) {
                e.toData[i].AutofillOrder = i;

                for (let j = 0; j < this.configs.length; j++) {
                    if (this.configs[j].AutoFillID === e.toData[i].AutoFillID) {
                        this.configs[j].AutofillOrder = i;
                    }
                }

            }
          this.isDataChanged =true;
        }
        catch (error)  {
            console.log(error);

        }


    }

    onDeleted(e)  {

        const idx = this.configs.findIndex(p => p.AutoFillID === e.AutoFillID);
        this.configs[idx].xauditDeleted = true;
      this.isDataChanged =true;

    }


  onTextChange() {
      this.isDataChanged=true;

  }
    // -----zoli





    onNew(event: any) {


        const newItem  = new EndoMultiToothExamAutoFillConfigurationModel();
        newItem.AutofillOrder = 99999;
        newItem.AutofillName = '-New-';

        this.configs.push(newItem);

        this.newItemCreted =true;

        //this.selectedConfig
        this.onSaveZ();



    }

    onDeleteClick(model: EndoMultiToothExamAutoFillConfigurationModel) {
        this.dialogService.openConfirmDialog(`Are you sure you want to delete ${model.AutofillName}?`).subscribe((res) => {
            if (res) {
                this.mtiService.deleteExamAutoFill(model).subscribe(() => {
                    let idx = this.configs.findIndex(p => p.AutoFillID === model.AutoFillID);
                    if (idx === 0) {
                        idx = this.configs.findIndex(p => p === model);
                    }
                    if (idx > -1) {
                        this.configs.splice(idx, 1);
                        this.table.updateData(this.configs);
                    }
                });
            }
        });
    }






    onSave()  {

      this.isDataChanged = true;
      console.log('save /change' );

    }

    onSaveZ() {

      if(this.selectedConfig) {
        const idx = this.configs.findIndex(p => p.AutoFillID === this.selectedConfig.AutoFillID);
        this.configs[idx] = this.selectedConfig;
      }

        this.mtiService.saveExamAutoFill(this.configs).subscribe((res) => {

          this.configs=[];
          this.loaddata();
        });

        /*
        this.mtiService.saveExamAutoFill(this.selectedConfig).subscribe((res) => {

            // send message to reload the autofill
            // this.messagingService.sendComponentMessage(MessagingConstants.MTI_AUTOFILL_CHANGED, true);
            // this.messagingService.broadCastMessage(MessagingConstants.MTI_AUTOFILL_CHANGED, true);
            this.messagingService.sendParentMessage(MessagingConstants.MTI_AUTOFILL_CHANGED, {});

            this.configurationService.setClean();
            const idx = this.configs.findIndex(p => p.AutoFillID === this.selectedConfig.AutoFillID);
            if (idx === -1) {
                this.selectedConfig = res;
                this.configs.unshift(this.selectedConfig);
                this.table.updateData(this.configs);
            }

            this.snackBar.open('Saved', 'Close', {
                duration: 2000,
                verticalPosition: 'top'
            });


        });

       */
    }

    onNameInputFinished(event: any) {
        this.selectedConfig.AutofillName = event;
        // this.onSave();
        this.table.updateData(this.configs);
        this.isDataChanged=true;
    }

    onOrderInputFinished(event: any ) {

        this.selectedConfig.AutofillOrder = event;
        // this.onSave();
        this.table.updateData(this.configs);

    }

    onVitalChange(event: MatCheckboxChange) {
        this.selectedConfig.isVital = event.checked;
      this.isDataChanged=true;
    // this.onSave();
    }

    onRowSelected(event: TdoTableSelectionEvent) {




        const l = this.configurationService.checkIsDirty();
        if (l) {
            l.subscribe((res) => {
                if (res) {
                    this.selectedConfig = null;
                    this.changeDet.detectChanges();


                    this.selectedConfig = event.model;
                    this.changeDet.detectChanges();
                    return;
                } else {
                    this.selectedConfig = null;
                    this.table.selectionControl.select(this.selectedConfig);
                    this.changeDet.detectChanges();
                }
            });
        } else {
            this.selectedConfig = null;
            this.changeDet.detectChanges();


            this.selectedConfig = event.model;
            this.changeDet.detectChanges();
        }
    }
}
